module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch06"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_vm._v("Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("W")])])]), _vm._v("hen Katherine Decker came home, the house was empty, that eerie quality a house has when it’s been left, quickly and without preparation. She saw the closet door was slightly ajar, his suitcases were gone and on the bedside table, he had left a note. She sat down on the bed to read it. The house was still, quiet. She heard the sound of her own breathing. Outside the window, the American elm, tall, majestic, casting a shadow on the sidewalk as the sun set, almost as if it were a protective blanket. It had rained the night before and the air was crisp, clean.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As always, he had left her a note")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('div', {
    staticClass: "extractLetter"
  }, [_c('p', {
    staticClass: "extractLetterSalutation"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dear Katherina")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ve had to leave (unexpectedly been called to New York, Julian Hawthorne has summoned me), and from there, I’m not sure where. I will send you a letter back and let you know when I expect to return. (Weeks, I imagine, this time.)")])]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I will think, all the time, that you are by my side. I will try to dodge whatever bullets come my way. And know, when you sleep, that I am next to you")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterSignature0"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Your husband,")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterSignature0"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Karl")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She held the note (as though it would somehow tell her more, where he had gone, where he would be sent to, this time) tightly in her fingers and read it again, as though the simple act of reading it would somehow keep him close to her.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("She had known when she married him that he was a journalist. That he had spent time in South America, in Cuba, had lived in the mountains for three months with Gomez and some of the other revolutionaries while working for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Journal")]), _vm._v(". Other women’s husbands worked. Some of them quite hard, but not like this. Ralph Thomas, Emma’s husband, sometimes stayed on the Senate floor till all hours (although they had their suspicions that there was something else involved, rumours about that he was a bit of a ladies’ man). But his schedule was predictable, he was never that far off. ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Emma could always track him down if she really wanted to. But living with Karl was something else. She never knew when she would come home and he would be…gone. Or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("how long")]), _vm._v(" he would, in fact, be gone for. Or where he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" gone.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Her sister Tess insisted that was part of the attraction. And, in the beginning, that might have been true.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Karl was terribly handsome, not in the way of other boys she had been raised with, there was something rougher about him, strong-shouldered, competent, dangerous, with those pale eyes that seemed to see through everything he witnessed and seemed to her to hold depths of understanding for everything that came before. He was well-travelled, but not in the usual society way—he could tell you about the mountains of Peru; the coast of Spain; he had travelled deep into parts of Africa; he knew things about politics and the way present-day politics related to earlier times, almost as if he were a historian, and yet he conversed with a certain passion she had never come in contact with before.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Yes, that was part of the attraction, at first. But as his disappearances had become more frequent, the accompanying anxiety about his return had also grown measurably.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“Not tonight, Katherine,” she chastened herself softly. “Don’t do this to yourself tonight.” Nathan would be ready for bed and waiting for her to tuck him in. Marguerite would have given him his bath by now. And brushed his hair, still wet, slicked back across his head. ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("That little angel face staring up at her from under his covers waiting to be kissed. Better not to let him know how much you missed his father. Don’t do this tonight. Marguerite has left a lamb in the kitchen and small roasted potatoes and peas sprinkled with butter and fresh mint. And there’s that little slip of an Edith Wharton book on the bedside table. Take it down with you. Pour a glass of port. And when you go to bed, say a prayer that he will return to you safely, as he always has before.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That was three and a half weeks ago, and she still had had no other word from him.")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69fc2330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/whiterose_ch06.vue
// module id = 90
// module chunks = 0